<div class="header-modal mb-0">
  <div class="main-title w-100 mt-0 mb-0">
    <h3>{{data?.params.type === 'pdf' ? 'Printing' : 'Exporting'}} ...</h3>
  </div>
</div>

<div class="modal-content">
  <div class="loader-aaaasf loader-aaaasf--modal">
    <div class="boxes">
      <div class="box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</div>

<div class="footer-modal">
  <cmp-button [class]="'cancel'" text="Cancel" (click)="cancelRequest()"></cmp-button>
</div>
